import { claimsApi } from '../../../data/claimsApi';
import type {
  ItemMasterEntriesResult,
  ItemMasterFreshnessResult,
} from './itemMasterTypes';

/**
 * Item Master feature endpoints, injected into the single Claims base api (CAM-C10 US3).
 * Read-only surface — no tag types needed (nothing here invalidates cache; see `data/tags.ts`).
 */
export const itemMasterEndpoints = claimsApi.injectEndpoints({
  endpoints: (builder) => ({
    getItemMasterFreshness: builder.query<ItemMasterFreshnessResult, void>({
      query: () => ({
        url: '/item-master/status',
        method: 'GET',
      }),
    }),

    getItemMasterEntries: builder.query<ItemMasterEntriesResult, { facilityId: string }>({
      query: ({ facilityId }) => ({
        url: '/item-master/entries',
        method: 'GET',
        params: { facilityId },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetItemMasterFreshnessQuery, useGetItemMasterEntriesQuery } = itemMasterEndpoints;
